import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';
import Button from '../../../general/inputs/Button';
import { updateConsultation } from '../../../../routes/doctor/consultation';
import { setIsConsent, setIsConsentPopupOpened, setIsFileExplorerPopupOpened } from '../../../../redux/features/doctor/Dashboard/consultation/consultation';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import FileExplorerContainer from '../../../doctor/dashboard/fileExplorer/FileExplorer';
import CancelButton from '../../../general/inputs/CancelButton';

interface Props { 

}; 

const FileExplorer: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 
    const isMobile = useMediaQuery('(max-width: 768px)');

    const { consultationId } = useParams(); 

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    const handleConsent = async () => { 

        const content = { 
            consultationId: consultationId,
            isConsentGiven: true
        }; 

        updateConsultation(content); 

        dispatch(setIsConsent(true)); 

        dispatch(setNotificationMessage(t('patientConsentEnabled'))); 

        dispatch(setIsConsentPopupOpened(false)); 

    }; 

    // -- 

    const handleQuit = () => { 

        dispatch(setIsFileExplorerPopupOpened(false)); 

    }; 
    
    // -- 

    return (

        <Box 
            onClick={handleQuit}
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                width: '100vw',
                height: '100vh', 
                backgroundColor: colors?.popup, 
                overflow: 'hidden', 
                position: 'absolute', 
                zIndex: 100000000,
        }}>

            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    justifyContent: 'center',
                    textAlign: 'center', 
                    width: '95vw', 
                    height: '90vh', 
                    padding: isMobile ? 1 : 2, 
                    borderRadius: isMobile ? 3 : 5,
                    fontSize: 14,
                    backgroundColor: colors?.container,
                    overflow: 'hidden'
                }}
            >

                <FileExplorerContainer extraStyle={{ height: '100%', width: '100%', borderRadius: 3 }}/>

            </Box>

            <CancelButton handler={handleQuit} />
            
        </Box>

  );

};

export default FileExplorer;